<template>
  <v-card class="ma-3 mt-0" >
    <v-card-title class="text-subtitle-1 grey lighten-3 text-break py-2">
      Details Unit
      <v-spacer></v-spacer>
      <v-btn
        v-if="!readonly"
        small
        color="primary"
        class="mr-2"
        @click="addUnit"
      >
        {{ unit && unit.id ? 'Update unit' : 'Add unit' }}
      </v-btn>
      <v-btn v-if="!readonly" @click="resetUnit"  small>Cancel</v-btn>
    </v-card-title>
    <v-card-text class="mt-3 pb-2">
      <v-form v-model="valid" ref="unitForm">
        <v-row no-gutters>
          <v-col
            cols="12"
            sm="9"
            :class="$vuetify.breakpoint.smAndUp ? 'pr-1' : 'pb-0'"
          >
            <v-row no-gutters class="mt-0">
              <v-col
                cols="12"
                sm="4"
                :class="$vuetify.breakpoint.smAndUp ? 'pr-1 pb-2' : 'pb-2'"
              >
                <c-autocomplete
                  v-model="unit.organisationId"
                  :items="organisations"
                  label="Affiliate/Distributor"
                  :readonly="readonly"
                  :rules="[$common.rules.required]"
                  class="required"
                ></c-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1 pb-2' : 'pb-2'"
              >
                <c-autocomplete
                  v-model="unit.modelId"
                  :items="availableModels"
                  label="Product"
                  :readonly="readonly"
                  :rules="[$common.rules.required]"
                  class="required"
                ></c-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                :class="$vuetify.breakpoint.smAndUp ? 'pl-1 pb-2' : 'pb-2'"
              >
                <c-select
                  v-model="unit.executionStatusId"
                  :items="executionStatusses"
                  label="Execution Status"
                  :readonly="readonly"
                ></c-select>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-0">
              <v-col
                cols="12"
                sm="4"
                :class="$vuetify.breakpoint.smAndUp ? 'pr-1 pb-2' : 'pb-2'"
              >
                <c-text-field
                  v-model="unit.localOrganisation"
                  label="Local Organisation"
                  :readonly="readonly"
                ></c-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1 pb-2' : 'pb-2'"
              >
                <c-text-field
                  v-model="unit.serial"
                  label="Serial"
                  :readonly="readonly"
                  :rules="[$common.rules.required]"
                  class="required"
                ></c-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                :class="$vuetify.breakpoint.smAndUp ? 'pl-1 pb-2' : 'pb-2'"
              >
                <date-picker
                  label="Tracing Date"
                  v-model="unit.dateOfTracing"
                  
                  @input="(value) => (unit.dateOfTracing = value)"
                  :readonly="readonly"
                ></date-picker>
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-0">
              <v-col
                cols="12"
                sm="4"
                :class="$vuetify.breakpoint.smAndUp ? 'pr-1 pb-2' : 'pb-2'"
              >
                <c-text-field
                  v-model="unit.localInChargePerson"
                  label="Local In Charge Person"
                  :readonly="readonly"
                ></c-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                :class="$vuetify.breakpoint.smAndUp ? 'px-1 pb-2' : 'pb-2'"
              >
                <c-select
                  v-model="unit.claimReferenceId"
                  :items="claimReferences"
                  label="ESV Claim Reference"
                  :readonly="readonly"
                ></c-select>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                :class="$vuetify.breakpoint.smAndUp ? 'pl-1 pb-2' : 'pb-2'"
              >
                <date-picker
                  label="Modification Date"
                  v-model="unit.modificationDate"
                  
                  @input="(value) => (unit.modificationDate = value)"
                  :readonly="readonly"
                ></date-picker>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="12"
            sm="3"
            :class="$vuetify.breakpoint.smAndUp ? 'pl-1' : ''"
          >
            <v-textarea
              outlined
              type="text"
              label="Remark"
              v-model="unit.remark"
              :background-color="readonly ? 'grey lighten-4' : ''"
              :disabled="readonly"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>

      <v-row>
        <v-col>
          <v-alert
            type="warning"
            
            v-if="
              !unitLoading &&
              validationMessages &&
              validationMessages.length > 0
            "
            text
          >
            <h3>Validation errors</h3>
            <div
              v-for="(validationMessage, index) in validationMessages"
              :key="index"
            >
              &bull; {{ validationMessage }}
            </div>
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <span class="text-caption pl-2">More Details</span>
      <v-btn icon @click="showMoreDetails = !showMoreDetails">
        <v-icon v-if="!showMoreDetails">mdi-plus</v-icon>
        <v-icon v-else>mdi-minus</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-text v-if="showMoreDetails" class="pt-0 pb-2">
      <v-row no-gutters>
        <v-col cols="12" sm="3" class="pa-0 ma-0">
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pr-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.customer"
              label="Customer"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pr-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.customerName"
              label="Customer Name"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pr-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.customerStreet"
              label="Customer Street"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pr-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.customerPostalCode"
              label="Customer Postal Code"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pr-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.customerCity"
              label="Customer City"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pr-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.customerCountry"
              label="Customer Country"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pr-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.customerType"
              label="Customer Type"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pr-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.customerOrderNr"
              label="Customer Order Nr"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
        </v-col>
        <v-col cols="12" sm="3" class="pa-0 ma-0">
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.shipTo"
              label="Ship To"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.shipToName"
              label="Ship To Name"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.shipToPostalCode"
              label="Ship To Postal Code"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.shipToCity"
              label="Ship To Postal City"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.shipToCountry"
              label="Ship To Country"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
        </v-col>
        <v-col cols="12" sm="3" class="pa-0 ma-0">
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.endCustomerName"
              label="End Customer Name"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.endCustomerStreet"
              label="End Customer Street"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.endCustomerPostalCode"
              label="End Customer Postal Code"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.endCustomerCity"
              label="End Customer City"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.endCustomerCountry"
              label="End Customer Country"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 px-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.endCustomerPhone"
              label="End Customer Phone"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
        </v-col>
        <v-col cols="12" sm="3" class="pa-0 ma-0">
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pl-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.reference"
              label="Reference"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pl-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.salesOrder"
              label="Sales Order"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pl-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.invoiceNr"
              label="Invoice Nr"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pl-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.invoiceNr2"
              label="Invoice Nr 2"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
          <v-col
            cols="12"
            :class="
              $vuetify.breakpoint.smAndUp ? 'pa-0 pl-1 pb-2' : 'pa-0 pb-2'
            "
          >
            <c-text-field
              v-model="unit.shipDate"
              label="Ship Date"
              :readonly="readonly"
            ></c-text-field>
          </v-col>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// @ is an alias to /src
import DatePicker from "../common/DatePicker.vue";

export default {
  name: "Edit",
  components: {
    DatePicker,
  },
  props: {
    esvId: Number,
    unitId: Number,
    readonly: Boolean,
    saveCounter: Number
  },
  data: () => ({
    showMoreDetails: false,
    unit: {},
    validationMessages: [],
    valid: false,
    unitLoading: false,

    //dropdown
    organisations: [],
    availableModels: [],
    executionStatusses: [],
    claimReferences: [],
  }),
  methods: {
    addUnit() {
      this.$refs.unitForm.validate();
      if (this.valid) {
        this.unitLoading = true;
        this.unit.esvId = this.esvId;
        if (this.unit.id) {
          this.$api
            .updateUnit(this.unit)
            .then(resp => {
              this.$toast.success('Unit has been updated')
              if (resp.data && resp.data.length > 0) {
                this.validationMessages = resp.data
              }
              else {
                this.resetUnit();
              }
              this.$emit('update');
            })
            .finally(() => (this.unitLoading = false));
        } else {
          this.$api
            .addUnit(this.unit)
            .then(resp => {
              this.$toast.success('Unit has been added')
              if (resp.data && resp.data.length > 0) {
                this.validationMessages = resp.data
              }
              else {
                this.resetUnit();
              }
              this.$emit('update');
            })
            .finally(() => (this.unitLoading = false));
        }
      }
    },
    resetUnit() {
      this.unit = {};
      this.$refs.unitForm.reset();
      this.validationMessages.length = 0;
    },
    getOrganisations() {
      // this.$api.getDistributionTargetsAsOrganisationByType(this.esvId).then((resp) => {
      this.$api.getAffiliatesAndDistributors(this.esvId).then((resp) => {
        this.organisations = resp.data;
      });
    },
    getModels() {
      this.$api.getAvailableModels(this.esvId).then((resp) => {
        this.availableModels = resp.data;
      });
    },
    getExecutionStatusses() {
      this.$api.getExecutionStatusses().then((resp) => {
        this.executionStatusses = resp.data;
      });
    },
    getClaimReferences() {
      this.$api
        .getClaimReferencesForEsv(this.esvId)
        .then((resp) => (this.claimReferences = resp.data));
    },
  },
  mounted() {
    this.getOrganisations();
    this.getModels();
    this.getExecutionStatusses();
    this.getClaimReferences();
  },
  watch: {
    unitId: {
      handler() {
        if (this.unitId) {
          this.validationMessages.length = 0;
          this.unitLoading = true;
          this.$api
            .getUnit(this.unitId)
            .then((resp) => (this.unit = resp.data))
            .finally(() => (this.unitLoading = false));
        }
      },
    },    
    saveCounter: {
      handler() {
        this.getOrganisations();
        this.getClaimReferences();
        this.getModels();
      }
    }
  },
};
</script>


<style scoped>
  .required >>> fieldset {
    border-left: 3px solid dodgerblue;
  }
  .dotted >>> fieldset {
    border-left: 3px dotted dodgerblue;
  }
  </style>